<template>
  <div>
    <div :class="$style.parent">
      <div :class="$style.notfound_bg"></div>
      <div :class="$style.notfound">
        <div :class="$style.notfound_404">
          <h1 class="text-center" style="text-align: center !important;">404</h1>
        </div>
        <h2 class="text-center" style="text-align: center !important;">{{ oracle.translate('صفحه مورد نظر یافت نشد') }}</h2>
        <div class="d-flex flex-row align-items-center align-content-center justify-center">
          <a class="text-center" style="text-align: center !important;" v-ripple role="button" @click="redirect('about')"
             :class="$style.contact_btn">{{ oracle.translate('درباره ما') }}</a>
          <a class="text-center" style="text-align: center !important;" v-ripple role="button" @click="redirect('/')"
             :class="$style.home_btn">{{ oracle.translate('صفحه اصلی سایت') }}</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import oracle from "../oracle";

export default {
  name: 'NotFound',
  data: () => ({
    oracle: oracle,
  }),
  methods: {
    redirect(page) {
      this.$router.push(page);
    }
  }
};
</script>
<style module>
.parent {
  position: relative;
  height: 100vh
}

.parent .notfound_bg {
  position: absolute;
  width: 100%;
  height: 100%;
  background-size: cover
}

.parent .notfound_bg:after {
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
}

.parent .notfound {
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%)
}

.notfound {
  max-width: 910px;
  width: 100%;
  line-height: 1.4;
  text-align: center
}

.notfound .notfound_404 {
  position: relative;
  height: 200px
}

.notfound .notfound_404 h1 {
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  font-size: 220px;
  font-weight: 900;
  margin: 0;
  color: #7ec352;
  text-transform: uppercase;
  letter-spacing: 10px
}

.notfound h2 {
  font-size: 22px;
  font-weight: 700;
  text-transform: uppercase;
  color: #222222;
  margin-top: 20px;
  margin-bottom: 15px
}

.notfound .home_btn,
.notfound .contact_btn {
  display: inline-block;
  font-weight: 700;
  text-decoration: none;
  background-color: transparent;
  border: 2px solid transparent;
  text-transform: uppercase;
  padding: 13px 25px;
  font-size: 18px;
  border-radius: 40px;
  margin: 7px;
  -webkit-transition: .2s all;
  transition: .2s all
}

.notfound .home_btn:hover,
.notfound .contact_btn:hover {
  opacity: .9
}

.notfound .home_btn {
  color: white;
  background: #222222;
}

.notfound .contact_btn {
  border: #222222 solid 3px;
  color: #222222
}

.notfound-social {
  margin-top: 25px
}

.notfound-social > a {
  display: inline-block;
  height: 40px;
  line-height: 40px;
  width: 40px;
  font-size: 14px;
  color: #222222;
  margin: 0 6px;
  -webkit-transition: .2s all;
  transition: .2s all
}

.notfound-social > a:hover {
  color: #222222;
  background-color: #222222;
  border-radius: 50%
}

@media only screen and (max-width: 767px) {
  .notfound .notfound_404 h1 {
    font-size: 182px
  }
}

@media only screen and (max-width: 480px) {
  .notfound .notfound_404 {
    height: 146px
  }

  .notfound .notfound_404 h1 {
    font-size: 146px
  }

  .notfound h2 {
    font-size: 16px
  }

  .notfound .home_btn,
  .notfound .contact_btn {
    font-size: 14px
  }
}
</style>